var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreenExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200.000000pt",
    height: "1200.000000pt",
    viewBox: "0 0 1200.000000 1200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4000 8835 l0 -835 -835 0 -835 0 0 -500 0 -500 1335 0 1335 0 0 1335 0 1335 -500 0 -500 0 0 -835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7000 8335 l0 -1335 1335 0 1335 0 0 500 0 500 -835 0 -835 0 0 835 0 835 -500 0 -500 0 0 -1335z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 4500 l0 -500 835 0 835 0 0 -835 0 -835 500 0 500 0 0 1335 0 1335 -1335 0 -1335 0 0 -500z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7000 3665 l0 -1335 500 0 500 0 0 835 0 835 835 0 835 0 0 500 0 500 -1335 0 -1335 0 0 -1335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenExit);
export default __webpack_public_path__ + "static/media/fullscreen_exit.6f7e4b240283dab72193ba5ac5513e9c.svg";
export { ForwardRef as ReactComponent };